import React from "react";
import AboutSystem from "./about-system";

class AboutSystemController extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            changeLogs: this.props.changeLogs,
            selectedLanguage: this.props.selectedLanguage
        }
    }

    componentDidMount(){
        this.getChangeLogsItems(this.props.selectedLanguage, this.props.currentPage, this.props.showedItemsCount);
    }

    getChangeLogsItems = (selectedLanguage, currentPage, showedItemsCount) => {
        this.props.getChangeLogs(selectedLanguage, currentPage, showedItemsCount);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.changeLogs !== nextState.changeLogs){
            this.setState({
                changeLogs: nextProps.changeLogs
            })
            return true;
        }
        if(nextProps.selectedLanguage !== nextState.selectedLanguage || nextProps.currentPage !== nextState.currentPage || nextProps.showedItemsCount !== nextState.showedItemsCount){
            this.getChangeLogsItems(nextProps.selectedLanguage, nextProps.currentPage, nextProps.showedItemsCount);
            this.setState({
                changeLogs: nextProps.changeLogs,
                selectedLanguage: nextProps.selectedLanguage,
                currentPage: nextProps.currentPage,
                showedItemsCount: nextProps.showedItemsCount
            })
            return true;
        }
        else{
            return false;
        }
    }

    render(){
        return (
            <AboutSystem
                getValue={this.props.getValue}
                changeLogs={this.props.changeLogs}
            />
        )
    }
}

export default AboutSystemController